import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { ErrorModel } from '@shared/models/ErrorModel';
import { PreciosService } from '../../precios.service';
import { read, utils, WorkBook, WorkSheet } from 'xlsx'
import { PrecioConsulta } from '@shared/models/precios/PrecioConsulta';
import { PrecioExcel } from '@shared/models/precios/PrecioExcel';
import { Guid } from 'guid-typescript';
import { TipoMoneda } from '@shared/enums/tipoMoneda';
import { EstadoPrecioCargado } from '@shared/enums/EstadoPrecioCargado';
import { StockService } from '@stock/stock.service';
import { Aeroplanta } from '@shared/models/stock/Aeroplanta';
import { ComparativaSubirPreciosComponent } from '../../precio/comparativa-subir-precios/comparativa-subir-precios.component';
import { MessageService } from '@shell/message.service';

@Component({
  selector: 'app-importacion-masiva',
  templateUrl: './importacion-masiva.component.html',
  styleUrls: ['./importacion-masiva.component.scss']
})
export class ImportacionMasivaComponent implements OnInit {

  @ViewChild('inputFile')
  inputFileForm: ElementRef;

  constructor(public modal: NgbActiveModal,
    private stockService: StockService,
    private fb: UntypedFormBuilder,
    private precioService: PreciosService,
    private modalService: NgbModal,
    private messageService: MessageService) { }

  fileUpload = { status: '', message: '', filePath: '', length: 0 };
  userFileName: string;
  mensajeError: string;
  subiendoPrecios: boolean = false;
  errorAlSubirPrecios: boolean = false;
  mensajeProcesamiento: string = null;
  mensajeErrorProcesamiento: string = "";
  mensajeFinProcesamiento: string = "";
  guidLote: Guid;
  CANTIDAD_PRECIOS_ENVIO: number = 100;
  cargaCancelada: boolean = false;
  obteniendoAeroplantas: boolean = false;
  errorObtenerAeroplantas: string;

  porcentajeCarga: number = 0;
  porcentajeMax: number = 100;
  idInterval;
  bloqueCompletado = 0;
  totalBloques = 0;

  comparativasRecibidas : PrecioConsulta[] = [];

  aeroplantasStock: Aeroplanta[] = [];

  niveles: any[] = [
    { id: "1", nombre: "1 - Producto/Vigencia/Moneda/Aeroplanta/Cliente/Tipo operación/Direccion de entrega" },
    { id: "2", nombre: "2 - Producto/Vigencia/Moneda/Aeroplanta/Cliente/Tipo operación" },
    { id: "3", nombre: "3 - Producto/Vigencia/Moneda/Aeroplanta/Cliente" },
    { id: "4", nombre: "4 - Producto/Vigencia/Moneda/Aeroplanta/Segmento" },
    { id: "5", nombre: "5 - Producto/Vigencia/Moneda/Aeroplanta/Area de Negocio" },
    { id: "6", nombre: "6 - Producto/Vigencia/Moneda/Aeroplanta" },

  ];

  listaNombreColumnasValidas : string[];

  productoForm = new UntypedFormGroup({
    nivelFormControl: new UntypedFormControl(),
  });

  timestampUltimaCarga: number = 0;
  timestampCargaActual: number = 0;

  // hooks

  ngOnInit() {
    this.productoForm = this.fb.group({
      name: [''],
      profile: [''],
      inputFile: ['', Validators.required],
      nivelFormControl: new UntypedFormControl(1)
    });
    this.nivel.setValue(6);

    this.obteniendoAeroplantas = true;
    this.stockService.obtenerAeroplantasStock().subscribe(result => {
      this.aeroplantasStock = result;
      
      this.obteniendoAeroplantas = false;
    },
    (err: ErrorModel) => {    
      this.errorObtenerAeroplantas = err.message;
      this.obteniendoAeroplantas = false;
    }
  );
  }

  // form

  resetearArchivo(){
    this.inputFileForm.nativeElement.value = "";
    this.userFileName = '';
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.productoForm.get('profile').setValue(file);
      this.productoForm.get('name').setValue(file.name);
      this.userFileName = file.name;
      this.timestampCargaActual = + new Date();
    }
  }

  reset(limpiarMensajes: boolean = false, limpiarInput: boolean = false) {
    this.subiendoPrecios = false;
    if (limpiarInput) {
      this.userFileName = '';
    }
    if (limpiarMensajes)
      this.fileUpload = { status: '', message: '', filePath: '', length: 0 };
  }

  // llamadas al service

  cargarPrecios() {
    if(this.timestampUltimaCarga == this.timestampCargaActual){
      this.messageService.showErrorMessage("Esta volviendo a cargar el mismo archivo. Si lo modifico, vuelva a seleccionarlo con el boton examinar para tomar los cambios.");
      return;
    }

    this.timestampUltimaCarga = this.timestampCargaActual;

    console.log(this.nivel.value);
    this.mensajeErrorProcesamiento = "";
    this.porcentajeCarga = 0;
    this.subiendoPrecios = true;
    this.fileUpload = { status: '', message: '', filePath: '', length: 0 };
    const archivo = this.productoForm.get('profile').value;

    if (archivo) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: WorkBook = read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: WorkSheet = wb.Sheets[wsname];

        /* save data */
        const rows: any[][] = utils.sheet_to_json(ws, { header: 1 });
        if (rows.length == 0) {
          this.mensajeError = "El archivo está vacío";
          this.reset();
        } else {

          if( ! this.validarColumnas(rows[0]) ){
            this.subiendoPrecios = false;
            return;
          }

          if( ! this.validarColumnasVacias(rows) ){
            this.subiendoPrecios = false;
            return;
          }

          if( ! this.validarPreciosTodosMismoTipo(rows)){
            this.subiendoPrecios = false;
           return;
          }

          if( ! this.validarFechasLegibles(rows)){
            this.subiendoPrecios = false;
           return;
          }

          const registros : any[][] = [];
          
          for (let i = 1; i <= this.cantidadFilasValidas(rows); i++) {            
            registros.push(this.convertirValoresEnString(rows[i]));
          }          

          this.iniciarProcesamientoPrecios(registros);
        }
      }

      reader.readAsBinaryString(this.productoForm.get('profile').value);
    } else {
      this.mensajeError = "No se seleccionó un archivo";
    }
  }

  obtenerNumeroAeroplantaPorCodigo(row: any[]){
    const tipoNivel = Number(this.nivel.value);    
    let codigo;

    if(tipoNivel <= 3){
      codigo = row[2];
    }else{
      codigo = row[1];
    }
    
    const aeroplanta = this.aeroplantasStock.filter(a => a.codigoAeroplanta == codigo)[0];

    if(aeroplanta != null){
      return aeroplanta.numeroAeroplanta;
    }else{
      return "";
    }    
  }

  convertirValoresEnString(fila: any[]){
    const registro = fila.map(e => e.toString());

    return this.convertirAeroplantaNumeroEnCodigo(registro);
  }

  convertirAeroplantaNumeroEnCodigo(registro: any[]){

    const campoAeroplanta = registro[this.obtenerIndiceColumnaAeroplanta()];

    if( ! isNaN(campoAeroplanta) ){
      // aeroplanta es un numero
      const aeroplanta = this.aeroplantasStock.filter(a => Number(a.numeroAeroplanta) == Number(campoAeroplanta))[0];

      if(aeroplanta != null){
        registro[this.obtenerIndiceColumnaAeroplanta()] = aeroplanta.codigoAeroplanta;
      }else{
        registro[this.obtenerIndiceColumnaAeroplanta()] = "" + campoAeroplanta;
      }
      
      return registro;
    }else{
      return registro;
    }
  }

  obtenerIndiceColumnaAeroplanta(){
    const tipoNivel = Number(this.nivel.value);    

    switch(tipoNivel){
      case 1: case 2: case 3:{
        return 2;
      }
      case 4: case 5: case 6:{
        return 1;
      }
    }

    return 1;
  } 

  obtenerCantColumansValidas(row: any[]){
    let cantColumnasValidas = 0;

    for(let i=0 ; i < row.length ; i++){
      if(row[i] == "" || row[i] == " " || row[i] == null){
        break;
      }
      cantColumnasValidas++;
    }

    return cantColumnasValidas;
  }

  validarFechasLegibles(rows: any[][]){
    const columnaFechadesde = this.listaNombreColumnasValidas.length - 3;

    for (let indexRow = 1; indexRow < rows.length; indexRow++) {  
      const fechadesde = rows[indexRow][columnaFechadesde];
      const fechaHasta = rows[indexRow][columnaFechadesde + 1];
      const fechaHoraRegex = /^\d{2}\/\d{2}\/\d{4} +\d{2}:\d{2}:\d{2} *(am|pm)?$/;

      if(fechadesde != null){
        if( ! fechaHoraRegex.test(fechadesde) ){
          this.mensajeErrorProcesamiento = "Hay un error en el formato de fecha desde, fila: " + (indexRow+1) + ". El formato esperado es dd/mm/yyyy hh:mm:ss [am/pm opcional] como por ejemplo 18/06/2021 05:45 am y se encontro " + fechadesde +"." ;
          return false;      
        }
      }

      if(fechaHasta != null){
        if( ! fechaHoraRegex.test(fechaHasta) ){
          this.mensajeErrorProcesamiento = "Hay un error en el formato de fecha hasta, fila: " + (indexRow+1) + ". El formato esperado es dd/mm/yyyy hh:mm:ss [am/pm opcional] como por ejemplo 18/06/2021 05:45 am y se encontro " + fechaHasta +"." ;
          return false;      
        }
      }
    }

    return true;
  }

  getCantidadColumnasValidas(){
    return this.listaNombreColumnasValidas.length;
  }

  cantidadFilasValidas(rows: any[][]){
    // Busca la primera fila con todas las columnas vacias.
    let indexRow, indexCol = 0;
    for (indexRow = 1; indexRow < rows.length; indexRow++) {   
      for(indexCol = 0; indexCol < this.getCantidadColumnasValidas(); indexCol++){
        if(rows[indexRow][indexCol] != null){
          break;
        }
      }

      if(indexCol == this.getCantidadColumnasValidas()){
        return indexRow-1;
      }
    }

    return indexRow - 1;
  }

  validarColumnasVacias(rows: any[][]){


    for (let indexRow = 1; indexRow < this.cantidadFilasValidas(rows); indexRow++) {   
      for(let indexCol = 0; indexCol < this.getCantidadColumnasValidas(); indexCol++){
        if(rows[indexRow][indexCol] == null){
          this.mensajeErrorProcesamiento = "El excel posee datos vacios en la fila: " + (indexRow + 1) + ", columna: " + String.fromCharCode(indexCol + 65) +"." ;
          return false;       
        }
      }               
    } 

    return true;
  }

  validarPreciosTodosMismoTipo(rows: any[][]){
    let registrosRetroactivos = 0;
    let registrosNoRetroactivos = 0;
    const columnaFechadesde = this.listaNombreColumnasValidas.length - 3;

    for (let indexRow = 1; indexRow < rows.length; indexRow++) {            
      if(rows[indexRow][columnaFechadesde] != null){
        try{
          const fechaDesdeFila = new Date( this.convertirCadenaFechaHora(rows[indexRow][columnaFechadesde]) ).getTime();
          const ahora = new Date().getTime();
  
          if(fechaDesdeFila < ahora){
            registrosRetroactivos++;
          }else{
            registrosNoRetroactivos++;
          }
        }catch(e){
          console.log(e);
        }        
      }
    } 

    if(registrosRetroactivos != 0 && registrosNoRetroactivos != 0){      
      this.mensajeErrorProcesamiento = "El excel posee precios retroactivos mezclados con no retroactivos. Precios retroactivos: " + registrosRetroactivos + ". Precios no retroactivos: " + registrosNoRetroactivos +"." ;
      return false;            
    }

    return true;
  }

  validarColumnas(row: any[]){
    const tipoNivel = Number(this.nivel.value);    
    const cantColumnasValidad = this.obtenerCantColumansValidas(row);
    const tipoOperacion = true;

    switch(tipoNivel){
      case 1:{
        this.listaNombreColumnasValidas = ["CodigoProducto", "CodigoCliente", "CodigoAeroplanta", (tipoOperacion ? "TipoOperacion" : "TipoVenta"), "Direccion", "TipoMoneda", "FechaDesde", "FechaHasta", "Precio"] ;        
        break;
      }
      case 2:{
        this.listaNombreColumnasValidas = ["CodigoProducto", "CodigoCliente", "CodigoAeroplanta", (tipoOperacion ? "TipoOperacion" : "TipoVenta"), "TipoMoneda", "FechaDesde", "FechaHasta", "Precio"] ;        
        break;
      }
      case 3:{
        this.listaNombreColumnasValidas = ["CodigoProducto", "CodigoCliente", "CodigoAeroplanta", "TipoMoneda", "FechaDesde", "FechaHasta", "Precio"] ;        
        break;
      }
      case 4:{
        this.listaNombreColumnasValidas = ["CodigoProducto", "CodigoAeroplanta", "CodigoSegmento", "TipoMoneda", "FechaDesde", "FechaHasta", "Precio"] ;        
        break;
      }
      case 5:{
        this.listaNombreColumnasValidas = ["CodigoProducto", "CodigoAeroplanta", "CodigoArea", "TipoMoneda", "FechaDesde", "FechaHasta", "Precio"] ;        
        break;
      }
      case 6:{
        this.listaNombreColumnasValidas = ["CodigoProducto", "CodigoAeroplanta", "TipoMoneda", "FechaDesde", "FechaHasta", "Precio"] ;        
        break;
      }
    }

    if(cantColumnasValidad != this.listaNombreColumnasValidas.length){
      this.mensajeErrorProcesamiento = "Error en encabezado de columna del excel. <br/>Se esperaban " + this.listaNombreColumnasValidas.length + " columnas para el nivel " + tipoNivel +" pero el excel tiene " + cantColumnasValidad + " columnas" ;
      return false;      
    }

    for(let i = 0; i < cantColumnasValidad; i++){
      if(row[i] != this.listaNombreColumnasValidas[i]){
        this.mensajeErrorProcesamiento = "Error en encabezado de columna del excel. Se esperaba '" + this.listaNombreColumnasValidas[i] + "' pero se encontro '" + row[i] +"' en la columna " + i ;
        return false;
      }
    }

    return true;
  }

  iniciarProcesamientoPrecios(rows : any[][]){
    this.guidLote = Guid.create();
    this.totalBloques = this.obtenerTotalBloques(rows.length);
    this.informarInicioDeProcesamiento(rows);
    this.procesarPrecios(rows, 1);   
  }

  calcularPorcentaje(rows: any[][], bloque){
    const totalBloques = this.totalBloques;

    return (bloque / totalBloques) * 100;
  }

  intervalPorcentajeCarga(rows: any[][], bloque: number) {
    clearInterval(this.idInterval);

    const inicial = this.calcularPorcentaje(rows, bloque - 1);
    const final = this.calcularPorcentaje(rows, bloque);

    const limiteVisual = final - 0.5;

    this.idInterval = setInterval(() => {
      if (this.porcentajeCarga < limiteVisual) {
        const delta = (final - inicial) / 60; // velocidad base
        this.porcentajeCarga = Math.min(this.porcentajeCarga + delta, limiteVisual);
      }
    }, 900);
  }

  procesarPrecios(rows: any[][], bloque: number){

    const precios = this.armarListaDePreciosPorBloque(rows, bloque);

    this.intervalPorcentajeCarga(rows, bloque);

    console.log("Subiendo bloque: " + bloque );

    this.errorAlSubirPrecios = false;

    this.precioService.subirPrecioLista(precios)
    .subscribe(
      rta => {
        if(this.cargaCancelada){
           // La llamada recursiva continuaba llamandese incluso al cerrarse la ventana. Con esto corta las llamadas recursivas.
           this.cancelarCarga();
           return;
        }

        this.informarBloqueProcesado(rows, bloque);

        clearInterval(this.idInterval);
        const porcentaje = this.calcularPorcentaje(rows, bloque);
        this.porcentajeCarga = Math.max(this.porcentajeCarga, porcentaje);
        
        this.comparativasRecibidas = this.comparativasRecibidas.concat(rta);

        if( this.todosLosBloquesProcesados(rows, bloque) ){
          this.informarFinProcesamiento(rows);
          this.subiendoPrecios = false;
          this.mostrarVentanaComparativa();
          return;
        }    

        this.procesarPrecios(rows, bloque+1);
      },
      (err: ErrorModel) => {
        console.log('Se ha producido un error', err);        
        clearInterval(this.idInterval);
        this.informarBloqueProcesado(rows,bloque);
        this.informarBloqueErroneo(rows, bloque, err.description);  
        this.errorAlSubirPrecios = true;      

        this.subiendoPrecios = false;
      }
    );

  }

  armarListaDePreciosPorBloque(rows: any[][], bloque){
    // rows es la lista de datos del excel sin encabezado
    // bloque 1 -> filas 0 a 99, bloque 2 -> filas 100 a 199
    
    const lista : PrecioExcel[] = [];

    const totalFilas = rows.length;

    for(let i=((bloque-1) * this.CANTIDAD_PRECIOS_ENVIO); (i < (this.CANTIDAD_PRECIOS_ENVIO * bloque)) && i < totalFilas; i++){
      const p = new PrecioExcel();
   
      p.id = this.guidLote.toString();
      p.nivel = Number(this.nivel.value);
      p.indice = (i+1);
      p.total = rows.length;
      p.filaExcel = rows[i];
      p.responsable = this.precioService.obtenerStringResponsableV2();
      p.numeroAeroplanta = this.obtenerNumeroAeroplantaPorCodigo(rows[i])

      p.observacion = this.verificarDuplicados(rows.slice(0, i), rows[i]);

      lista.push(p);
    }

    return lista;
  }

  convertirCadenaFechaHora(cadenaOriginal: string){

    const dia = cadenaOriginal.substring(0, 2);
    const mes = cadenaOriginal.substring(3, 5);    

    return mes + "/" + dia + "/" + cadenaOriginal.substring(6, cadenaOriginal.length);
  }

  verificarDuplicados(rows: any[][], fila: string[]){

    const cantColumnas = this.listaNombreColumnasValidas.length - 3;

    for(let indexRow = 0; indexRow < rows.length; indexRow++){
      for(let i=0 ; i < cantColumnas; i++){
        if(rows[indexRow][i] != fila[i]){
          break;
        }

        if( i == (cantColumnas-1) ){
          try{
            const fechaDesdePrecio = new Date( this.convertirCadenaFechaHora(rows[indexRow][i+1]) ).getTime();
            const fechaDesdeFila = new Date( this.convertirCadenaFechaHora(fila[i+1]) ).getTime();
  
            const fechaHastaPrecio = new Date( this.convertirCadenaFechaHora(rows[indexRow][i+2]) ).getTime();
            const fechaHastaFila = new Date( this.convertirCadenaFechaHora(fila[i+2]) ).getTime();
  
            // Comparamos y es igual en todo salvo fechaDesde, fechaHasta y precio (hasta ahora)
            if(fechaDesdePrecio == fechaDesdeFila && fechaHastaPrecio == fechaHastaFila && Number(rows[indexRow][i+3]) == Number(fila[i+3])){
              //Camparamos y es exactamente igual el precio
              return "Precio duplicado dentro del archivo excel con la linea " + (indexRow+2);
            }
  
            if(fechaDesdePrecio == fechaDesdeFila && fechaHastaPrecio == fechaHastaFila){
              //Camparamos y es igual en todo menos en precio
              return "Fechas superpuestas dentro del archivo excel con la linea " + (indexRow+2);
            }
  
            if(fechaDesdeFila <= fechaHastaPrecio && fechaHastaFila >= fechaDesdePrecio){
              return "Fechas superpuestas dentro del archivo excel con la linea " + (indexRow+2);
            }
          }catch(ex){
            console.log("excepcion al verificar precio:" + ex);            
          }      
        }
      }
    }

    return "";     
  }

  todosLosBloquesProcesados(rows: any[][], bloque){

    let totalBloques = (rows.length / this.CANTIDAD_PRECIOS_ENVIO);
    const totalEnviosNumeroRedondo = ( totalBloques % 1) == 0;

    if( !totalEnviosNumeroRedondo ){
      totalBloques = Math.floor(totalBloques) + 1;
    }

    if( bloque >= totalBloques ){
      return true;
    }else{
      return false
    }
  }

  obtenerTotalBloques(cantFilas){
    let totalBloques = (cantFilas / this.CANTIDAD_PRECIOS_ENVIO);
    const totalEnviosNumeroRedondo = ( totalBloques % 1) == 0;

    if( !totalEnviosNumeroRedondo ){
      totalBloques = Math.floor(totalBloques) + 1;
    }

    return totalBloques;
  }

  informarInicioDeProcesamiento(rows: any[][]){
    this.mensajeProcesamiento = "Se inicia el procesamiento de " + rows.length + " precios.";
  }

  informarBloqueProcesado(rows: any[][], bloque){
    let registrosProcesados;
    if(bloque == this.totalBloques){
      registrosProcesados = rows.length;
    }else{
      registrosProcesados = (bloque * this.CANTIDAD_PRECIOS_ENVIO);
    }

    this.bloqueCompletado = bloque; console.log("Bloque completado: " + this.bloqueCompletado );

    this.mensajeProcesamiento = "Se procesaron " + registrosProcesados + " precios de un total de " + rows.length + " precios del excel.";
  }

  informarFinProcesamiento(rows: any[][]){
    this.mensajeProcesamiento = null;
    this.mensajeFinProcesamiento = "Se ha terminado de procesar los " + rows.length + " precios del excel.";
    // Mostrar icono OK verde
  }

  informarBloqueErroneo(rows: any[][], bloque, descripcionErrorHttp){
    this.mensajeErrorProcesamiento = "Error al enviar un bloque de precios al servidor. Se interrumpe el procesamiento.<br/>";
    this.mensajeErrorProcesamiento += "El bloque" + bloque + " del excel dio el siguiente error: " + descripcionErrorHttp;
  }

  obtenerTipoMoneda(textoSimboloMoneda){
    if(textoSimboloMoneda == "ARP"){
      return TipoMoneda.PES;
    }else{
      return TipoMoneda.USD;
    }
  }

  mostrarVentanaComparativa(){
    const modalRef = this.modalService.open(ComparativaSubirPreciosComponent, { centered: true, size: "lg", windowClass: 'myCustomModalClass', backdrop: "static" });
    modalRef.componentInstance.guidLote = this.guidLote;
    modalRef.componentInstance.nivelPrecio =  this.nivel.value;
    modalRef.componentInstance.preciosConsulta =  this.comparativasRecibidas;
    modalRef.result.then(() => { this.reiniciarVentana(); }, () => { this.reiniciarVentana(); });
  }

  reiniciarVentana(){
    this.guidLote = null;
    this.fileUpload = { status: '', message: '', filePath: '', length: 0 };
    this.userFileName = '';
    this.porcentajeCarga = 0;
    this.bloqueCompletado = 0;
    this.totalBloques = 0;
    this.comparativasRecibidas = [];
    this.errorAlSubirPrecios = false;
    this.mensajeProcesamiento = null;
    this.mensajeErrorProcesamiento = "";
    this.mensajeFinProcesamiento = "";
    this.subiendoPrecios = false;

    this.ngOnInit();
  }

  usuarioCancelaCarga(){
    // Si no se esta subiendo precios llamar a cancelarCarga
    if(this.bloqueCompletado == this.totalBloques){
      this.cancelarCarga();
      return;
    }

    if(this.errorAlSubirPrecios){
      this.cancelarCarga();
      return;
    }

    // Si se esta subiendo precios
    this.cargaCancelada = true;
  }

  cancelarCarga(){
    if(this.guidLote){
      this.precioService.uploadV2(this.guidLote, EstadoPrecioCargado.Cancelado)
      .subscribe(() => {
        this.cargaCancelada = false;
        this.messageService.showSuccessLongMessage("Se cancelo la carga realizada.")
        this.subiendoPrecios = false;
        this.reiniciarVentana();
        },
        (err: ErrorModel) => {
          this.cargaCancelada = false;
          this.subiendoPrecios = false;
          this.mensajeError = err.description + ' ' + err.message;     
        }
      );    
    }
  }

  // getters

  get nivel() {
    return this.productoForm.get('nivelFormControl');
  }

  descargarPlantilla() {
    const nivel = this.nivel.value;
    window.open('/assets/excel-niveles/PreciosNivel' + nivel + '.xlsx', '_blank');
  }

}




